const Vue = require('vue')

Vue.component('humanized-money', {
    props: {
        value: {
            required: true
        }
    },
    template: `<span class="humanized-money" v-if="value > 0" v-tooltip :vtitle="value | money">{{ value | humanizedMoney }}</span>`
})

Vue.component('humanized-number', {
    props: {
        value: {
            required: true
        }
    },
    template: `<span class="humanized-number" v-if="value > 0" v-tooltip :vtitle="value">{{ value | humanizedNumber }}</span>`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/humanized-money.js